module.exports = __webpack_public_path__ + "static/ae3-ed5fd83618d729a4eb99b783af856529.svg";